import { AppDataActionTypesKeys, SetAppDataAction } from '@store/action-types/app-data-action-types'
import { AppData } from '@models/app-data'

export function setAppData(appData: AppData): SetAppDataAction {
  return { type: AppDataActionTypesKeys.SET_APP_DATA, payload: appData }
}
